import { HEJA_STATS } from '~/config/stats'
import useTranslator from '~/lib/useTranslator'

function TrustBanner() {
  const Translator = useTranslator()
  return (
    <div className="bg-linear-to-b from-primary-color to-white to-50% from-50%">
      <div className="max-w-5xl mx-4 md:mx-auto bg-primary-color-dark py-2 md:py-6 rounded-xl shadow-lg z-10 md:bg-[url('/images/trust-bg.svg')] bg-cover bg-center bg-no-repeat">
        <div className="flex flex-1 flex-col md:flex-row justify-between items-center">
          <div className="text-white md:text-3xl text-center flex flex-1 gap-2 justify-center py-4 bg-[url('/images/trust-bg-mobile.svg')] bg-center md:bg-none bg-no-repeat w-full">
            {Translator.singular('Trusted by')}{' '}
            <strong>
              {Translator.singular('{{ noOfTeams }} Teams', { noOfTeams: HEJA_STATS.teamCount })}
            </strong>
          </div>

          <div className="items-center justify-center flex flex-1 gap-4 py-4 bg-[url('/images/trust-bg-mobile.svg')] bg-no-repeat bg-center md:bg-none w-full">
            <svg className="w-28 h-4">
              <use xlinkHref="#totalstars" />
            </svg>
            <div className="text-white md:text-3xl">
              <strong>{HEJA_STATS.appStoreRating}</strong> {Translator.singular('from')}{' '}
              <strong>{HEJA_STATS.appStoreRatingCount}</strong> {Translator.singular('ratings')}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrustBanner
